import React from "react"
import styles from "./labeled-input.module.scss"

export interface LabeledInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "className"> {
  label: string
  error?: string
  className?: string
}

const NO_TRIM_TYPES = new Set(["password", "number", "date", "time"]);

export const LabeledInput = React.forwardRef<HTMLInputElement, LabeledInputProps>(
  ({ label, error, className = "", disabled, type = "text", ...inputProps }, ref) => {
    const { onBlur: onBlurFromInputProps, ...restInputProps } = inputProps;

    const wrappedInputProps = inputProps.onChange && !NO_TRIM_TYPES.has(type)
      ? {
          ...restInputProps,
          onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
            const trimmed = e.target.value.trim();
            if (trimmed !== e.target.value) {
              e.target.value = trimmed;
              inputProps.onChange!(e as unknown as React.ChangeEvent<HTMLInputElement>);
            }
            onBlurFromInputProps?.(e);
          },
        }
      : inputProps;

    return (
      <div className={`${styles.fieldWrapper} ${className}`}>
        <label
          className={`${styles.inputGroup} ${error ? styles.inputGroupError : ""} ${disabled ? styles.disabled : ""}`}
        >
          <span className={styles.inputLabel}>{label}</span>
          <input
            ref={ref}
            className={styles.input}
            disabled={disabled}
            type={type}
            {...wrappedInputProps}
          />
        </label>
        {error && <span className={styles.errorMessage}>{error}</span>}
      </div>
    )
  }
)

LabeledInput.displayName = "LabeledInput"
